import { observer } from 'mobx-react-lite'
import { useLocalNumbersStepsContext } from 'pages/settings/pages/compliance/pages/localNumbers/context/localNumbersStepsContext'
import { LocalNumbersRoutes } from 'pages/settings/pages/compliance/pages/localNumbers/route/type'
import { usePathSegment } from 'pages/settings/pages/compliance/hooks/usePathSegment'
import { CommonOptInPaperFormContent } from 'pages/settings/pages/compliance/ui/CommonOptInContent/ui/CommonOptInPaperFormContent'
import { AiCheckerNextButtons } from 'pages/settings/pages/compliance/ui/AiCheckerNextButton/AiCheckerNextButtons'

export const OptInPaperFormContent = observer(() => {
  const {
    optInConsentStore,
    stepLoading,
    aiSidebarStore: {
      isAiCheckrWillUse,
      isLoading: aiLoading,
      isSuccessButton,
      isErrorButton,
      isContinueWithIssues,
    },
  } = useLocalNumbersStepsContext()
  const {
    getOptInImagesAsAttach,
    deleteAttachment,
    clearAttachmentError,
    getIsNextDisabled,
    getOptInAttachmentError,
    campaignOptInContentNextClick,
    uploadOptInImageAttachment,
    commonOptInConsentStore,
  } = optInConsentStore
  const lastPathSegment = usePathSegment<LocalNumbersRoutes>()

  return (
    <CommonOptInPaperFormContent
      stepLoading={stepLoading}
      getOptInImagesAsAttach={() =>
        getOptInImagesAsAttach(LocalNumbersRoutes.optInPaperFormContent)
      }
      deleteAttachment={(url: string) =>
        deleteAttachment(url, LocalNumbersRoutes.optInPaperFormContent)
      }
      uploadAttachment={(attachments: File[]) =>
        uploadOptInImageAttachment(attachments, lastPathSegment)
      }
      increaseStep={() => campaignOptInContentNextClick(lastPathSegment)}
      clearAttachmentError={() => clearAttachmentError(lastPathSegment)}
      getIsNextDisabled={() => getIsNextDisabled(lastPathSegment)}
      getAttachmentError={() => getOptInAttachmentError(lastPathSegment)}
      optInConsentStore={commonOptInConsentStore}
      aiCheckrButton={
        isAiCheckrWillUse && (
          <AiCheckerNextButtons
            loading={aiLoading}
            disabled={getIsNextDisabled(lastPathSegment) || aiLoading}
            text='Check and continue'
            onClick={() => campaignOptInContentNextClick(lastPathSegment, true)}
            icon='stars'
            isSuccess={isSuccessButton}
            isError={isErrorButton}
            isContinueWithIssues={isContinueWithIssues}
            onContinueWithIssuesClick={() => campaignOptInContentNextClick(lastPathSegment)}
            isContinueWithIssuesLoading={stepLoading}
          />
        )
      }
    />
  )
})
